import React, { useEffect } from 'react';

import styles from './index.scss';

interface Props {
  className?: string;
}

const FullScreenModal: React.FC<Props> = ({ children, className = '' }) => {
  /*
   * Fix scrolling issues
   */
  useEffect(() => {
    document.body.classList.add(styles.freezeBody);
    document.querySelector('[data-pagelet-container-id=footer-navigation]')?.classList.add(styles.hideFooter);
    return () => {
      document.body.classList.remove(styles.freezeBody);
      document.querySelector('[data-pagelet-container-id=footer-navigation]')?.classList.remove(styles.hideFooter);
    };
  }, []);

  return <div className={`${styles.fullScreenModal} ${className}`}>{children}</div>;
};

export default FullScreenModal;
